<template>
  <div class="testimonials-section">
    <div class="container-fluid px-0">
      <div class="testimonials-header">
        <h2 class="testimonials-title">KLIENTŲ ATSLIEPIMAI</h2>
        <div class="testimonials-divider"></div>
        <p class="testimonials-subtitle">Ką sako mūsų klientai apie mūsų paslaugas</p>
      </div>

      <div class="testimonials-grid">
        <div 
          v-for="(testimonial, index) in testimonials" 
          :key="index"
          class="testimonial-card"
        >
          <div class="testimonial-rating">
            <svg v-for="n in 5" :key="n" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" class="star-icon">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
          </div>
          <p class="testimonial-text">"{{ testimonial.text }}"</p>
          <div class="testimonial-author">
            <div class="testimonial-avatar">
              {{ testimonial.initials }}
            </div>
            <div class="testimonial-info">
              <p class="testimonial-name">{{ testimonial.firstName }}{{ testimonial.lastName ? ' ' + testimonial.lastName : '' }}</p>
              <p class="testimonial-location">{{ testimonial.location }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Testimonials',
  props: {
    type: {
      type: String,
      default: 'auto', // 'auto' or 'digging'
      validator: (value) => ['auto', 'digging'].includes(value)
    }
  },
  computed: {
    testimonials() {
      if (this.type === 'auto') {
        return [
          {
            text: "Puikiai atlikti darbai, greitai ir profesionaliai. Automobilis veikia kaip naujas! Rekomenduoju!",
            firstName: "Jonas",
            lastName: "P.",
            location: "Vilnius",
            initials: "JP"
          },
          {
            text: "Greitai atsakė į užklausą, laikėsi sutartų terminų, profesionaliai atliko visus darbus, padėjo kitais rūpimais klausimais. Didelė padėka. Rekomenduoju.",
            firstName: "Vida",
            lastName: "",
            location: "Jieznas",
            initials: "V"
          },
          {
            text: "Darbai atlikti itin greitai ir kokybiškai. Automobilis sutvarkytas puikiai - matosi profesionalumas ir atsakomybė už savo darbą. Malonus bendravimas, aiškūs terminai ir tikrai super rezultatas. Ačiū",
            firstName: "Edvinas",
            lastName: "J",
            location: "Kaunas",
            initials: "EJ"
          }
        ]
      } else {
        return [
          {
            text: "Puikiai atlikti žemės kasimo darbai. Profesionaliai, greitai ir tvarkingai. Rekomenduoju!",
            firstName: "Jonas",
            lastName: "P.",
            location: "Vilnius",
            initials: "JP"
          },
          {
            text: "Labai patenkintas paslaugomis. Sklypas paruoštas statybai per kelias dienas. Puikūs specialistai!",
            firstName: "Petras",
            lastName: "K.",
            location: "Kaunas",
            initials: "PK"
          },
          {
            text: "Profesionalus žemės lyginimas ir formavimas. Tikrai grįšiu dar kartą. Geros kainos!",
            firstName: "Marija",
            lastName: "J.",
            location: "Alytus",
            initials: "MJ"
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
.testimonials-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  padding: 80px 20px;
}

.testimonials-header {
  text-align: center;
  margin-bottom: 60px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.testimonials-title {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(2rem, 4vw, 2.5rem);
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 20px;
  letter-spacing: -0.02em;
}

.testimonials-divider {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #dc3545, #ff6b6b);
  border-radius: 2px;
  margin: 0 auto 20px;
}

.testimonials-subtitle {
  font-family: 'Open Sans', sans-serif;
  font-size: 1.1rem;
  color: #6c757d;
  margin: 0;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.testimonial-card {
  background: white;
  border-radius: 16px;
  padding: 40px 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
}

.testimonial-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(220, 53, 69, 0.15);
  border-color: #dc3545;
}

.testimonial-rating {
  display: flex;
  gap: 4px;
  margin-bottom: 20px;
}

.star-icon {
  width: 20px;
  height: 20px;
  color: #ffc107;
}

.testimonial-text {
  font-family: 'Open Sans', sans-serif;
  font-size: 1rem;
  line-height: 1.7;
  color: #1a1a1a;
  margin: 0 0 24px 0;
  flex: 1;
  font-style: italic;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.testimonial-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #dc3545, #ff6b6b);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.testimonial-info {
  flex: 1;
}

.testimonial-name {
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 4px 0;
}

.testimonial-location {
  font-family: 'Open Sans', sans-serif;
  font-size: 0.875rem;
  color: #6c757d;
  margin: 0;
}

@media (max-width: 768px) {
  .testimonials-section {
    padding: 60px 15px;
  }
  
  .testimonials-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  
  .testimonial-card {
    padding: 30px 24px;
  }
}
</style>

